/* eslint-disable react/prop-types */
import { useState } from "react";
import loadDictionary from "../../plugins/locale/load-dictionary";
import ApiAppService from "../../service/api-app-service";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";

const apiAppService = new ApiAppService();

await loadDictionary('api-app-create-window');

function CreateApiAppWindow({isOpenWindow, onCloseWindow}) {
	const [appName, setAppName] = useState('');
	const [appDescription, setAppDescription] = useState('');
	const [appEmail, setAppEmail] = useState('');
	// const [appOwnerId, setAppOwnerId] = useState(null);
	const [tokenScopes, setTokenScopes] = useState('');
	// const [tokenExpiresAt, setTokenExpiresAt] = useState(null);
	const [token, setToken] = useState(null);

	const handleClose = () => { 
			setAppName('');
			setAppDescription('');
			setAppEmail('');
			// setAppOwnerId(null);
			setTokenScopes('');
			// setTokenExpiresAt(null);
			setToken(null);

			onCloseWindow();
  };

	const handleSubmit = () => {

		const apiApp = {
			app_name: appName,
			app_description: appDescription,
			app_email: appEmail,
			app_owner_id: null,
			token_scopes: null,
			token_expires_at: null,
		};

		apiAppService.create(apiApp).then(result => {
			if(result) {
				setToken(result.api_app.token_hash);
				// handleClose();
			}
		}).catch(error => {
			console.error(error);
		})
	}

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("api-app-create-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="CreateForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("api-app-create-window.app_name")}</Form.Label>
						<Form.Control type="text" autoFocus value={appName} onChange={e => {setAppName(e.target.value)}} />
          </Form.Group>
					<Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("api-app-create-window.app_email")}</Form.Label>
						<Form.Control type="text" value={appEmail} onChange={e => {setAppEmail(e.target.value)}} />
          </Form.Group>
					<Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("api-app-create-window.app_token_scopes")}</Form.Label>
						<Form.Control type="text" value={tokenScopes} onChange={e => {setTokenScopes(e.target.value)}} />
          </Form.Group>
					<Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("api-app-create-window.app_description")}</Form.Label>
						<Form.Control type="text" value={appDescription} onChange={e => {setAppDescription(e.target.value)}} />
          </Form.Group>
					<Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("api-app-create-window.token_hash")}</Form.Label>
						<Form.Control type="text" value={token} readOnly />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("api-app-create-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="CreateForm" disabled={token} >{i18n.t("api-app-create-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateApiAppWindow;